import { Button } from '@/components/Button/Button';
import {
  ButtonsWrapper,
  ContentWrapper,
  FeaturedWrapper,
  Message,
  MessageBody,
  MessageHeader,
  WarningIcon,
} from '../Modal.styles';
import { GenericFailureModalPropTypes } from './GenericFailureModal.styles';

export function GenericFailureModal({
  onCancel,
}: GenericFailureModalPropTypes): JSX.Element {
  return (
    <ContentWrapper>
      <FeaturedWrapper>
        <WarningIcon width={102} height={102} />
      </FeaturedWrapper>
      <Message>
        <MessageHeader>Oops!</MessageHeader>
        <MessageBody>
          Looks like we ran into an issue. Please try again later.
        </MessageBody>
      </Message>
      <ButtonsWrapper>
        <Button onClick={onCancel}>Cancel</Button>
      </ButtonsWrapper>
    </ContentWrapper>
  );
}
